import styled from 'styled-components'
import { device } from './breakpoints'

export const OuterPadding = styled.div<IOuterWrapperProps>`
  padding: 40px 0;
  z-index: 3;
  position: relative;
  background: ${props => props.backgroundColor ? props.backgroundColor : 'none'};
  @media ${device.tablet} {
      padding: 80px 0;
  }
  @media ${device.laptopL} {
      //padding: 120px 0;
  }
`

export const OuterPaddingTop = styled.div<IOuterWrapperProps>`
  padding-top: 40px;
  background: ${props => props.backgroundColor ? props.backgroundColor : 'none'};
  @media ${device.tablet} {
      padding-top: 80px;
  }
`

export const OuterPaddingBottom = styled.div<IOuterWrapperProps>`
  padding-bottom: 40px;
  background: ${props => props.backgroundColor ? props.backgroundColor : 'none'};
  @media ${device.tablet} {
      padding-bottom: 80px;
  }
`

interface IAltBackground {
  altBg?: boolean
}

export const OuterPaddingTheme = styled.div<IAltBackground>`
  padding: 40px 0;
  background: ${props => {
  return props.altBg ? props.theme.backgroundSecondary : props.theme.backgroundPrimary
}};
  overflow: hidden;
  @media ${device.tablet} {
    padding: 100px 0;
}`
export const Container = styled.div`
  position: relative;
  width: auto;
  margin: auto;
  padding: 0 15px;
  @media ${device.laptop}{
    width: 970px;
  }
  @media ${device.laptopL}{
    width: 1170px;
    
  }
`

export const ContainerTablet = styled.div`
  max-width: 768px;
  margin: 0 auto;
  @media ${device.laptop}{
    max-width: 821px;
  }
`

interface IOuterWrapperProps {
  backgroundColor?: string
}

export const MedImgWrapper = styled.div`
  margin: 0 auto;
  max-width: 600px;
`
export const OuterWrapper = styled(OuterPadding)<IOuterWrapperProps>`
  background: ${props => props.backgroundColor};
`
export const VerticalWrapper = styled(OuterPaddingTheme)`
  padding-bottom: 0;
  @media ${device.tablet}{
    padding-bottom: 0;
  }
`
export const checkmarkColorClasses = [
  'purple',
  'pink',
  'green',
  'yellow',
  'teal',
  'pink',
  'orange',
  'green',
  'purple',
  'yellow',
]
export const getCheckmarkClasses = () => {
  return `
    &.purple{
      color: #9e3f93;
      svg{
        path{
          fill: #9e3f93;
        }
      }
    }
    
    &.pink{
      color: #ef6981;
      svg{
        path{
          fill: #ef6981;
        }
      }
    }
    
    &.teal{
      color: #01b7b8;
      svg{
        path{
          fill: #01b7b8;
        }
      }
    }
    
    &.yellow{
      color: #f3c100;
      svg{
        path{
          fill: #f3c100;
        }
      }
    }
    
    &.green{
      color: #00d47f;
      svg{
        path{
          fill: #00d47f;
        }
      }
    }
    
    &.orange{
      color: #ff9900;
      svg{
        path{
          fill: #ff9900;
        }
      }
    }
  `
}
